import React from "react";
import {
  StyledMatchPromoLabel,
  StyledMatchPromoLabelPrefix,
  StyledMatchPromoText,
} from "./StyledMatchPromoLink";
import { Link } from "../../../Link/Link";

function MatchPromoLink({ callToAction, prefix }) {
  if (!callToAction.displayText || !callToAction.url) {
    return null;
  }

  return (
    <StyledMatchPromoLabel className="mls-c-match-promo__promo-link">
      {prefix && (
        <StyledMatchPromoLabelPrefix>{prefix} </StyledMatchPromoLabelPrefix>
      )}
      <Link
        url={callToAction.url}
        alt={callToAction.accessibleText}
        target={callToAction.openInNewTab ? "_blank" : "_self"}
        rel={callToAction.openInNewTab ? "noopener noreferrer" : ""}
      >
        <StyledMatchPromoText>{callToAction.displayText}</StyledMatchPromoText>
      </Link>
    </StyledMatchPromoLabel>
  );
}

export default MatchPromoLink;
